<template>
  <div class="status">
    <div class="list">
      <div class="button" :class="{ success: isPrepareSuccess }" />
      <span class="name">แบบร่าง</span>
    </div>
    <div class="list">
      <div class="button" :class="{ success: isSendFormSuccess }" />
      <span class="name">ส่งแบบร่าง</span>
    </div>
    <div class="list">
      <div class="button" :class="{ success: isInstructorSuccess }" />
      <span class="name">ผ่านที่ปรึกษา</span>
    </div>
    <div class="list">
      <div class="button" :class="{ success: isOsdaSuccess }" />
      <span class="name">ผ่านองค์การฯ</span>
    </div>
    <div class="list">
      <div class="button" :class="{ success: isSuccess }" />
      <span class="name">{{ lastStatus }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    status
  },
  data () {
    return {
      isPrepareSuccess: false,
      isSendFormSuccess: false,
      isInstructorSuccess: false,
      isOsdaSuccess: false,
      isSuccess: false,
      lastStatus: 'รอการอนุมัติ'
    }
  },
  mounted () {
    if (this.status === 'แบบร่าง') {
      this.isPrepareSuccess = true
    } else if (this.status === 'รอการอนุมัติจากอาจารย์ที่ปรึกษา') {
      this.isPrepareSuccess = true
      this.isSendFormSuccess = true
    } else if (this.status === 'อยู่ระหว่างการพิจารณา') {
      this.isPrepareSuccess = true
      this.isSendFormSuccess = true
      this.isInstructorSuccess = true
    } else if (this.status === 'อนุมัติ') {
      this.isPrepareSuccess = true
      this.isSendFormSuccess = true
      this.isInstructorSuccess = true
      this.isOsdaSuccess = true
      this.isSuccess = true
      this.lastStatus = 'อนุมัติ'
    } else if (this.status === 'ไม่อนุมัติ') {
      this.isPrepareSuccess = true
      this.isSendFormSuccess = true
      this.isInstructorSuccess = true
      this.isOsdaSuccess = true
      this.isSuccess = false
      this.lastStatus = 'ไม่อนุมัติ'
    }
  }
}
</script>

<style lang="scss" scoped>
  .status {
    display: inline-flex;
    text-align: center;
    .list {
      text-align: center;
      margin-right: 8px;
      .button {
        background: #FF4949;
        border: 3px #BC3636 solid;
        border-radius: 10px;
        width: 18px;
        height: 18px;
        display: inline-block;
        &.success {
          background: #28D094;
          border: 3px #18996C solid
        }
      }
      .name {
        display: block;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/js/components/projects/ProjectStatus.vue